import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KeyboardInputService {
  numericRegex = /^(0|[1-9][0-9]*)$/;
  inputRegex = /(^\d*[.]?\d{0,4}$)|(^\d*[ |-]?\d+[\\/]\d+$)/;
  /**
   * Function to check valid value for a numeric only keyboard.
   *
   * @param {KeyboardEvent} event
   * @return {boolean}
   * @memberof KeyboardInputService
   */
  numericKeyboard(event: KeyboardEvent): boolean {
    // NOTE: Valid Keys are: 0~9 (keycodes: 48~57 and 96~105[windows numberpad]), left and right arrow keys, shift, caps-lock, backspace, and delete keys
    // NOTE: `event.key` is the recomended property but some browsers might still not support this property. `event.keyIdentifier` or `event.keyCode` will be the fall back.
    if (event.key) {
      return (
        (Number.isFinite(Number(event.key)) && event.key !== ' ') ||
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowRight' ||
        event.key === 'Backspace' ||
        event.key === 'CapsLock' ||
        event.key === 'Del' ||
        event.key === 'Shift' ||
        event.key === 'Tab'
      );
    } else if (event.keyCode) {
      return (
        (Number.isFinite(Number(String.fromCharCode(event.keyCode))) &&
          event.keyCode !== 32) ||
        (event.keyCode >= 96 && event.keyCode <= 105) ||
        event.keyCode === 8 || // backspace key
        event.keyCode === 9 || // Tab key
        event.keyCode === 16 || // shift key
        event.keyCode === 20 || // capslock key
        event.keyCode === 37 || // left arrow
        event.keyCode === 39 || // right arrow
        event.keyCode === 46
      ); // delete key
    }

    return false;
  }

  /**
   * Checks whether a keyboard event is a ctrl action (e.g. copy/paste)
   *
   * @param {KeyboardEvent} { ctrlKey, metaKey, key }
   * @returns {boolean}
   * @memberof KeyboardInputService
   */
  isCtrlAction({ ctrlKey, metaKey, key }: KeyboardEvent): boolean {
    switch (key) {
      case 'a':
      case 'c':
      case 'v':
      case 'x':
      case 'z':
      case 'Control':
      case 'Meta':
        return ctrlKey || metaKey;
    }

    return false;
  }

  /**
   * Validates the paste data for the input field
   * @param {ClipboardEvent} clipboardData
   * @param { string } pasteType
   * @return { boolean }
   * @memberof KeyboardInputService
   */
  validatePasteData(clipboardData: ClipboardEvent, pasteType: string) {
    const data = clipboardData.clipboardData;
    const regex = pasteType === 'number' ? this.numericRegex : this.inputRegex;

    return data && regex.test(data.getData('text'));
  }
}
